// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__6QAt6","hideOnTablet":"styles_hideOnTablet__Gah3e","hideOnMobile":"styles_hideOnMobile__13atx","card":"styles_card__30bYO"};